<aura-dialog-layout [title]="'Se retirer de la candidature'" [hideCancel]="true">
  <div dialog-content class="flex flex-col gap-4 py-2 max-w-xl">
    <!-- Notice 1: Avertissement & conséquences irréversibles -->
    <div class="flex items-start gap-3.5 rounded-xl border border-red-6/60 bg-red-2/50 p-4">
      <div
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-red-3 text-red-11 border border-red-5"
      >
        <mat-icon class="size-5 !text-xl">warning</mat-icon>
      </div>
      <div class="flex-1">
        <h3 class="font-bold text-red-12 m-0 text-sm">Action irréversible et libération de place</h3>
        <p class="mt-1 text-xs text-red-11 leading-relaxed m-0">
          En confirmant votre désistement, votre candidature sera définitivement clôturée et retirée de
          l'espace comparatif du vendeur. <strong>Votre place sera libérée</strong> pour permettre à d'autres
          agents certifiés de postuler sur ce bien.
        </p>
      </div>
    </div>

    <!-- Notice 2: Non-remboursement des crédits -->
    <div class="flex items-start gap-3.5 rounded-xl border border-neutral-4 bg-neutral-2/70 p-4">
      <div
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-neutral-3 text-neutral-11 border border-neutral-4"
      >
        <mat-icon class="size-5 !text-xl">monetization_on</mat-icon>
      </div>
      <div class="flex-1">
        <h3 class="font-bold text-neutral-12 m-0 text-sm">Crédits d'engagement non remboursables</h3>
        <p class="mt-1 text-xs text-neutral-10 leading-relaxed m-0">
          La plateforme ayant mis en relation les parties et fourni les informations du bien, les crédits
          consommés lors de votre positionnement initial restent acquis et ne font l'objet d'aucun
          remboursement.
        </p>
      </div>
    </div>

    <!-- Notice 3 (optionnel): Visite associée -->
    @if (data?.hasAppointment) {
      <div class="flex items-start gap-3.5 rounded-xl border border-amber-6/50 bg-amber-2/40 p-3.5">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-amber-3 text-amber-11">
          <mat-icon class="size-4 !text-lg">event_busy</mat-icon>
        </div>
        <div class="flex-1">
          <p class="text-xs text-amber-12 font-medium m-0 leading-relaxed">
            Les créneaux de visite convenus ou planifiés avec le propriétaire seront automatiquement annulés.
          </p>
        </div>
      </div>
    }

    <!-- Sélection du motif (optionnel mais utile) -->
    <div class="flex flex-col gap-2.5 pt-1">
      <span class="text-xs font-semibold text-neutral-11 uppercase tracking-wider">
        Motif du retrait (optionnel)
      </span>
      <div class="flex flex-wrap gap-2">
        @for (item of predefinedReasons; track item) {
          <button
            type="button"
            (click)="selectReason(item)"
            class="px-3 py-1.5 text-xs font-medium rounded-lg border transition-all cursor-pointer text-left"
            [class]="
              reason() === item
                ? 'bg-neutral-12 text-white border-neutral-12 shadow-xs'
                : 'bg-neutral-2 text-neutral-11 border-neutral-4 hover:bg-neutral-3'
            "
          >
            {{ item }}
          </button>
        }
      </div>
    </div>

    <!-- Message libre pour le vendeur -->
    <div class="flex flex-col pt-4">
      <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
        <mat-label>Message ou motif précisé pour le vendeur</mat-label>
        <textarea
          matInput
          rows="3"
          [ngModel]="reason()"
          (ngModelChange)="reason.set($event)"
          placeholder="Ex : Écart important entre notre estimation et le prix espéré..."
        ></textarea>
      </mat-form-field>
    </div>
  </div>

  <div
    dialog-actions
    class="flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-end gap-3 w-full pt-2"
  >
    <button mat-stroked-button type="button" (click)="onCancel()" class="text-xs font-semibold !py-3 !px-4">
      <span>Annuler</span>
    </button>
    <button
      mat-flat-button
      type="button"
      (click)="onConfirm()"
      class="destructive primary text-xs font-bold !py-3 !px-5"
    >
      <span>Confirmer le retrait</span>
    </button>
  </div>
</aura-dialog-layout>
